import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL, IPlanDto } from '@/dtos';

interface Params {
  organizationId?: string;
}
const QUERY_KEY = 'GET_OMNIBUS_PLANS';
const useGetOmnibusPlansQuery = ({ organizationId }: Params) => {
  const { data, isLoading, isSuccess, isError } = useQuery(
    [QUERY_KEY, organizationId],
    () =>
      api.get<IPlanDto[]>(API_URL.REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_BREAKDOWN_PLANS, {
        params: {
          employer_id: organizationId,
        },
      }),
    {
      retry: 0,
      enabled: !!organizationId,
    }
  );
  const options = useMemo(() => {
    const list = data?.data || [];
    const currentOptions: Option[] = list.map((item) => ({
      key: item.id || '',
      value: item.name || '',
      title: item.name?.name || '',
    }));
    return currentOptions;
  }, [data?.data]);
  return {
    options,
    isError,
    isSuccess,
    isLoading,
  };
};

export default useGetOmnibusPlansQuery;
